import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Access Gate
      "accessGateTitle": "Event Access",
      "bridegroomNames": "VASILIKI & RODRIGO",
      "accessGateSubtitle": "Please enter your access code to continue",
      "accessCodePlaceholder": "Enter access code",
      "accessGateButton": "Enter Event",
      "accessCodeInvalid": "Invalid access code. Please try again.",
      "privateAccessNote": "Private access for invited guests only",
      // Hero
      "welcome": "We are getting married!",
      "eventSubtitle": "Join us for an unforgettable celebration",
      "dateofevent": "at June 06, 2026",
      "date": "Date",
      "time": "Time",
      "location": "Location",
      "rsvpNow": "RSVP Now",
      "youAreInvited": "You're invited",
      "rsvpDeadlineDisclaimer": "Please RSVP by May 1st, 2026. If you need to cancel after confirming, please inform us by the end of May per email.",

      // Timeline
      "timeline": "Event Timeline",
      "timelineSubtitle": "Here's what we have planned for you",
      "arrival": "Arrival & Welcome",
      "arrivalDesc": "Arrival at the church Agios Georgios",
      "cocktail": "Church Ceremony",
      "cocktailDesc": "Celebrate the union",
      "dinner": "Arrival at the dinner venue Ballux Beach Bar",
      "dinnerDesc": "Welcome drinks, appetizers, and seating",
      "party": "Dinner & Cake Cutting",
      "partyDesc": "Enjoy a buffet dinner and dessert",
      "memories": "Party Time",
      "memoriesDesc": "Dance the night away",
      
      // Photos
      "shareMemories": "Share Your Memories",
      "shareMemoriesDesc": "Upload your photos to our shared album",
      "uploadPhotos": "Upload Photos",
      "uploadPhotosDesc": "Share your favorite moments from the event",
      "uploadNow": "Upload Now",
      "allFormats": "All Formats Welcome",
      "allFormatsDesc": "Photos, videos, and more",
      "sharedAlbum": "Shared Album",
      "sharedAlbumDesc": "Everyone can view and download",
      "easyUpload": "Easy Upload",
      "easyUploadDesc": "Simple drag and drop interface",
      "viewGallery": "View & Download Photos",
      "noLoginNeeded": "No app or login needed.",
      "uploadTip": "Tip: Use Wi-Fi for large videos; photos upload fastest from your phone’s browser.",
      "uploadSuccess": "Thanks! Your photos were uploaded.",
      "uploading": "Uploading...",
      "filesSelected": "files selected",
      "galleryComingSoon": "Gallery avaibable after the wedding",
      
      // Location
      "eventLocation": "Event Location",
      "eventLocationDesc": "Find us here on the big day",
      "nameOfVenue": "Ekklisia Agiou Georgiou & Ballux Beach Bar",
      "address": "Address",
      "location": "Kato Lechonia in Volos, Greece",
      "phone": "Phone",
      "directions": "Directions",
      "getDirections": "Get Directions",
      "openInMaps": "Open in Google Maps",
      "parkingInfo": "Parking Information",
      "parkingInfoDesc": "Free parking available on-site of the venue",

      // Gift / Bank details
      "gift.intro": "Your presence is the greatest gift and we do not expect anything else! If you would like to give us something regardless, we would appreciate a contribution towards our future with a bank transfer. Following are the details:",
      "gift.germanyTitle": "Germany (SEPA)",
      "gift.greeceTitle": "Greece (SEPA)",
      "gift.paypalTitle": "PayPal",
      "gift.accountHolder": "Account holder",
      "gift.iban": "IBAN",
      "gift.bic": "BIC",
      "gift.paypalEmail": "PayPal Email",
      "gift.paypalUsername": "PayPal Username",
      "gift.reference": "Reference",
      "gift.referenceValue": "Wedding gift – Your Name",
      "gift.copyIban": "Copy IBAN",
      "gift.copyEmail": "Copy Email",
      "gift.copyAll": "Copy all details",
      "gift.privacyNote": "For your privacy, please include only your name in the transfer reference. Thank you so much!",

      //FAQ
      "faq.title": "Frequently Asked Questions",
      "faq.subtitle": "Everything you need to know about our big day",
      "faq.question1": "What time should I arrive?",
      "faq.answer1": "We recommend arriving at 18:45. The ceremony will begin at the church promptly at 19:00. This gives you time to find parking and get settled.",
      "faq.question2": "Is there a dress code?",
      "faq.answer2": "We suggest cocktail/semi-formal attire. Be aware that the venue after the church is at the beach, therefore choose your shoes accordingly (wedges or block heels work better than stilettos on sand).",
      "faq.question3": "Where should I stay?",
      "faq.answer3": "We've collected a list of recommended Airbnb accommodations near the church and the house where we will be getting ready. Click on the accommodation section above to view our Airbnb list. We recommend booking early as June is peak season in the area.",
      "faq.question4": "How do I get to Volos?",
      "faq.answer4": "Here are your transportation options:<br/><br/>• <strong>Athens Airport (ATH)</strong>: 3-hour drive. Options:<br/>  - Rent a car for flexibility<br/>  - Take bus from <a href='https://ktelvolou.gr/en/routes/map/&map=greece' target='_blank' rel='noopener noreferrer' style='color: #2563eb; text-decoration: underline; font-weight: 600;'>Athens Bus Station (KTEL)</a> to Volos (4 hours)<br/><br/>• <strong>Thessaloniki Airport (SKG)</strong>: 2.5-hour drive. Options:<br/>  - Rent a car for flexibility<br/>  - Direct bus from <a href='https://ktelmacedonia.gr/en/routes/tid=26' target='_blank' rel='noopener noreferrer' style='color: #2563eb; text-decoration: underline; font-weight: 600;'>Thessaloniki Bus Station (KTEL)</a> to Volos (2.5 hours)<br/><br/>We recommend landing in Thessaloniki if possible, as it's closer to Volos.<br/><br/>Once in Volos, you can take the local bus to reach Kato Lechonia, which is about a 20-minute drive from Volos center.<br/><br/>If you’re taking the bus from Thessaloniki or Athens to Volos, please note that at the bus station you might need to look for “Magnesia” (the regional name) instead of just “Volos”. Volos is the main city of the region of Magnesia — so both names can appear on signs or tickets.<br/><br/><b/><b/>Please don't hesitate to reach out if you need any assistance with transportation.",
      "faq.question5": "Can I bring my children?",
      "faq.answer5": "Children are welcome! Please include them in your RSVP. We'll have some activities for kids, but we recommend bringing items to keep them entertained during the ceremony.",
      "faq.question6": "What about gifts?",
      "faq.answer6": "Your presence is the greatest gift and we do not expect anything else! If you would like to give us something regardless, we would appreciate a contribution towards our honeymoon fund. There will be a gift box at the reception.",
      "faq.moreQuestions": "Still have questions?",
      "faq.contactUs": "Contact Us",
      "faq.emailSubject": "Wedding Question",

      // Accommodation
      "accommodation.title": "Where to Stay",
      "accommodation.description": "We've created a list with comfortable accommodations near our venue and the place where we will be getting ready. Browse the curated Airbnb list for the best places to stay during your visit.",
      "accommodation.viewAirbnbs": "View Recommended Accommodations",
      "accommodation.bookEarly": "Book early for the best availability and prices!",    

      // RSVP Form
      "rsvp": "RSVP",
      "rsvpDesc": "Please let us know if you can join us",
      "personalInfo": "Personal Information",
      "firstName": "First Name",
      "lastName": "Last Name",
      "firstNamePlaceholder": "John",
      "lastNamePlaceholder": "Doe",
      "contactInfo": "Contact Information",
      "email": "Email",
      "guestInfo": "Guest Information",
      "adultsAllowed": "Number of Adults (max 2)",
      "childrenAllowed": "Number of Children (max 5)",
      "adult": "Adult",
      "child": "Child",
      "adults": "Adults",
      "children": "Children",
      "additionalInfo": "Additional Information",
      "allergies": "Food Allergies",
      "allergiesPlaceholder": "Please list any food allergies or dietary restrictions",
      "notes": "Additional Notes",
      "notesPlaceholder": "Any special requests or information we should know?",
      "submit": "Submit RSVP",
      "submitting": "Submitting...",
      "thankYou": "Thank You!",
      "rsvpConfirmed": "Your RSVP has been confirmed. We look forward to seeing you!",
      "submitAnother": "Submit Another RSVP",
      "errorSubmitting": "Error submitting RSVP. Please try again.",
      // Footer
      "footer": "Join our wedding celebration! Made with ❤️ by Vasiliki & Rodrigo."
    }
  },
  de: {
    translation: {
      // Access Gate
      "accessGateTitle": "Event-Zugang",
      "bridegroomNames": "VASILIKI & RODRIGO",
      "accessGateSubtitle": "Bitte geben Sie Ihren Zugangscode ein, um fortzufahren",
      "accessCodePlaceholder": "Zugangscode eingeben",
      "accessGateButton": "Event betreten",
      "accessCodeInvalid": "Ungültiger Zugangscode. Bitte versuchen Sie es erneut.",
      "privateAccessNote": "Privater Zugang nur für eingeladene Gäste",
      // Hero
      "welcome": "Wir heiraten!",
      "eventSubtitle": "Feiert diesen besonderen Tag mit uns.",
      "dateofevent": "06. Juni 2026",
      "date": "Datum",
      "time": "Uhrzeit",
      "location": "Ort",
      "rsvpNow": "Jetzt anmelden",
      "youAreInvited": "Sie sind eingeladen",
      "rsvpDeadlineDisclaimer": "Bitte melden Sie sich bis zum 1. Mai 2026 an. Absagen bitte bis Ende Mai per E-Mail.",
      
      // Timeline
      "timeline": "Veranstaltungszeitplan",
      "timelineSubtitle": "Das haben wir für Sie geplant",
      "arrival": "Ankunft & Begrüßung",
      "arrivalDesc": "Ankunft in der Kirche Agios Georgios",
      "cocktail": "Kirchliche Trauung",
      "cocktailDesc": "Feier der Eheschließung",
      "dinner": "Ankunft am Dinnerveranstaltungsort Ballux Beach Bar",
      "dinnerDesc": "Willkommensgetränke, Vorspeisen und Platzanweisung",
      "party": "Abendessen & Anschneiden der Torte",
      "partyDesc": "Genießen Sie ein Buffet-Dinner und Dessert",
      "memories": "Party-Zeit",
      "memoriesDesc": "Tanzen Sie die Nacht durch",
      
      // Photos
      "shareMemories": "Teilen Sie Ihre Erinnerungen",
      "shareMemoriesDesc": "Laden Sie Ihre Fotos in unser gemeinsames Album hoch",
      "uploadPhotos": "Fotos hochladen",
      "uploadPhotosDesc": "Teilen Sie Ihre Lieblingsmomente von der Veranstaltung",
      "uploadNow": "Jetzt hochladen",
      "allFormats": "Alle Formate willkommen",
      "allFormatsDesc": "Fotos, Videos und mehr",
      "sharedAlbum": "Gemeinsames Album",
      "sharedAlbumDesc": "Jeder kann ansehen und herunterladen",
      "easyUpload": "Einfaches Hochladen",
      "easyUploadDesc": "Einfache Drag-and-Drop-Oberfläche",
      "viewGallery": "Fotos ansehen & herunterladen",
      "noLoginNeeded": "Keine App oder Anmeldung erforderlich.",
      "uploadTip": "Tipp: Verwenden Sie WLAN für große Videos; Fotos laden am schnellsten über den Handy-Browser hoch.",
      "uploadSuccess": "Danke! Ihre Fotos wurden hochgeladen.",
      "uploading": "Wird hochgeladen...",
      "filesSelected": "Dateien ausgewählt",
      "galleryComingSoon": "Galerie verfügbar nach der Hochzeit",
      
      // Location
      "eventLocation": "Veranstaltungsort",
      "eventLocationDesc": "Finden Sie uns hier am großen Tag",
      "nameOfVenue": "Ekklisia Agiou Georgiou & Ballux Beach Bar",
      "address": "Adresse",
      "location": "Kato Lechonia in Volos, Griechenland",
      "phone": "Telefon",
      "directions": "Wegbeschreibung",
      "getDirections": "Wegbeschreibung abrufen",
      "openInMaps": "In Google Maps öffnen",
      "parkingInfo": "Parkinformationen",
      "parkingInfoDesc": "Kostenlose Parkplätze vor Ort des Veranstaltungsortes verfügbar",

      // Gift / Bank details
      "gift.intro": "Ihre Anwesenheit ist das größte Geschenk und wir erwarten nichts anderes! Wenn Sie uns trotzdem etwas geben möchten, würden wir uns über einen Beitrag zu unserer Zukunft mit einer Banküberweisung freuen. Hier sind die Details:",
      "gift.germanyTitle": "Deutschland (SEPA)",
      "gift.greeceTitle": "Griechenland (SEPA)",
      "gift.paypalTitle": "PayPal",
      "gift.accountHolder": "Kontoinhaber",
      "gift.iban": "IBAN",
      "gift.bic": "BIC",
      "gift.paypalEmail": "PayPal E-Mail",
      "gift.paypalUsername": "PayPal Benutzername",
      "gift.reference": "Verwendungszweck",
      "gift.referenceValue": "Hochzeitsgeschenk – Ihr Name",
      "gift.copyIban": "IBAN kopieren",
      "gift.copyEmail": "E-Mail kopieren",
      "gift.copyAll": "Alle Details kopieren",
      "gift.privacyNote": "Für Ihre Privatsphäre geben Sie bitte nur Ihren Namen im Verwendungszweck der Überweisung an. Vielen Dank!",

      //FAQ
      "faq.title": "Häufig gestellte Fragen",
      "faq.subtitle": "Alles, was Sie über unseren großen Tag wissen müssen",
      "faq.question1": "Wann soll ich ankommen?",
      "faq.answer1": "Wir empfehlen, um 18:45 Uhr anzukommen. Die Zeremonie beginnt pünktlich um 19:00 Uhr in der Kirche. So haben Sie Zeit, einen Parkplatz zu finden und sich einzufinden.",
      "faq.question2": "Gibt es einen Dresscode?",
      "faq.answer2": "Wir empfehlen Cocktail-/Semi-Formal-Kleidung. Beachten Sie, dass der Veranstaltungsort nach der Kirche am Strand liegt, wählen Sie daher Ihre Schuhe entsprechend (Keilabsätze oder Blockabsätze funktionieren besser als Stilettos im Sand).",
      "faq.question3": "Wo soll ich übernachten?",
      "faq.answer3": "Wir haben eine Liste empfohlener Airbnb-Unterkünfte in der Nähe des Veranstaltungsortes und des Hauses, in dem wir uns vorbereiten werden, zusammengestellt. Klicken Sie auf den Abschnitt Unterkunft oben, um die Liste der Airbnb-Unterkünfte zu sehen. Wir empfehlen, frühzeitig zu buchen, da der Juni in der Region Hochsaison ist.",
      "faq.question4": "Wie komme ich nach Volos?",
      "faq.answer4": "Hier sind Ihre Transportmöglichkeiten:<br/><br/>• <strong>Flughafen Athen (ATH)</strong>: 3 Stunden Fahrt. Optionen:<br/>  - Auto mieten für Flexibilität<br/>  - Bus von der <a href='https://ktelvolou.gr/en/routes/map/&map=greece' target='_blank' rel='noopener noreferrer' style='color: #2563eb; text-decoration: underline; font-weight: 600;'>Athen Busstation (KTEL)</a> nach Volos (4 Stunden)<br/><br/>• <strong>Flughafen Thessaloniki (SKG)</strong>: 2,5 Stunden Fahrt. Optionen:<br/>  - Auto mieten für Flexibilität<br/>  - Direktbus von der <a href='https://ktelmacedonia.gr/en/routes/tid=26' target='_blank' rel='noopener noreferrer' style='color: #2563eb; text-decoration: underline; font-weight: 600;'>Thessaloniki Busstation (KTEL)</a> nach Volos (2,5 Stunden)<br/><br/>Wir empfehlen, wenn möglich in Thessaloniki zu landen, da es näher zu Volos liegt.<br/><br/>Einmal in Volos können Sie den lokalen Bus nehmen, um Kato Lechonia zu erreichen, was etwa 20 Minuten Fahrt vom Zentrum von Volos entfernt ist.<br/><br/>Wenn Sie mit dem Bus von Thessaloniki oder Athen nach Volos fahren, beachten Sie bitte, dass an der Bushaltestelle möglicherweise „Magnisia“ (der Name der Region) statt nur „Volos“ ausgeschildert ist. Volos ist die Hauptstadt der Region Magnisia – daher können beide Bezeichnungen auf Schildern oder Tickets erscheinen.<br/><br/><b/><b/>Bitte zögern Sie nicht, uns zu kontaktieren, wenn Sie Hilfe beim Transport benötigen.",
      "faq.question5": "Kann ich meine Kinder mitbringen?",
      "faq.answer5": "Kinder sind willkommen! Bitte geben Sie sie in Ihrer RSVP an. Wir werden einige Aktivitäten für Kinder haben, aber wir empfehlen, Gegenstände mitzubringen, um sie während der Zeremonie zu beschäftigen.",
      "faq.question6": "Was ist mit Geschenken?",
      "faq.answer6": "Ihre Anwesenheit ist das größte Geschenk und wir erwarten nichts anderes! Wenn Sie uns trotzdem etwas geben möchten, würden wir uns über einen Beitrag zu unserem Flitterwochenfonds freuen. Es wird eine Geschenkschachtel auf der Rezeption geben.",
      "faq.moreQuestions": "Haben Sie noch Fragen?",
      "faq.contactUs": "Kontaktieren Sie uns",
      "faq.emailSubject": "Hochzeitsfrage",
      // Accommodation
      "accommodation.title": "Wo übernachten",
      "accommodation.description": "Wir haben eine Liste mit Unterkünften in der Nähe unseres Veranstaltungsortes erstellt. Durchsuchen Sie die Airbnb-Liste für die besten Übernachtungsmöglichkeiten während Ihres Besuchs.",
      "accommodation.viewAirbnbs": "Empfohlene Unterkünfte ansehen",
      "accommodation.bookEarly": "Buchen Sie frühzeitig für die beste Verfügbarkeit und Preise!",

      // RSVP Form
      "rsvp": "Anmeldung",
      "rsvpDesc": "Bitte teilen Sie uns mit, ob Sie teilnehmen können",
      "personalInfo": "Persönliche Informationen",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "firstNamePlaceholder": "Max",
      "lastNamePlaceholder": "Mustermann",
      "contactInfo": "Kontaktinformationen",
      "email": "E-Mail",
      "guestInfo": "Gästeinformationen",
      "adultsAllowed": "Anzahl Erwachsene (max 2)",
      "childrenAllowed": "Anzahl Kinder (max 5)",
      "adult": "Erwachsener",
      "child": "Kind",
      "children": "Kinder",
      "adults": "Erwachsene",
      "additionalInfo": "Zusätzliche Informationen",
      "allergies": "Lebensmittelallergien",
      "allergiesPlaceholder": "Bitte listen Sie alle Lebensmittelallergien oder Ernährungseinschränkungen auf",
      "notes": "Zusätzliche Notizen",
      "notesPlaceholder": "Besondere Wünsche oder Informationen, die wir wissen sollten?",
      "submit": "Anmeldung senden",
      "submitting": "Wird gesendet...",
      "thankYou": "Vielen Dank!",
      "rsvpConfirmed": "Ihre Anmeldung wurde bestätigt. Wir freuen uns auf Sie!",
      "submitAnother": "Weitere Anmeldung einreichen",
      "errorSubmitting": "Fehler beim Senden der Anmeldung. Bitte versuchen Sie es erneut.",
      // Footer
      "footer": "Feiern Sie mit uns unsere Hochzeit! Mit ❤️ gemacht von Vasiliki & Rodrigo."
    }
  },
  el: {
    translation: {
      // Access Gate
      "accessGateTitle": "Πρόσβαση στην Εκδήλωση",
      "bridegroomNames": "ΒΑΣΙΛΙΚΗ & RODRIGO",
      "accessGateSubtitle": "Παρακαλώ εισάγετε τον κωδικό πρόσβασής σας για να συνεχίσετε",
      "accessCodePlaceholder": "Εισαγάγετε τον κωδικό πρόσβασης",
      "accessCodeInvalid": "Μη έγκυρος κωδικός πρόσβασης. Παρακαλώ δοκιμάστε ξανά.",
      "accessGateButton": "Είσοδος στην εκδήλωση",
      "privateAccessNote": "Ιδιωτική πρόσβαση μόνο για προσκεκλημένους καλεσμένους",

      // Hero
      "welcome": "Παντρευόμαστε!",
      "eventSubtitle": "Ελάτε να γιορτάσουμε μαζί αυτή τη μέρα.",
      "dateofevent": "06 Ιουνίου 2026",
      "date": "Ημερομηνία",
      "time": "Ώρα",
      "location": "Τοποθεσία",
      "rsvpNow": "Επιβεβαίωση παρουσίας",
      "youAreInvited": "Είστε προσκεκλημένοι",
      "rsvpDeadlineDisclaimer": "Παρακαλούμε ενημερώστε μας για τη συμμετοχή σας έως την 1η Μαΐου 2026. Σε περίπτωση ακύρωσης, έως τις 20 Μαΐου.",

      // Timeline
      "timeline": "Χρονοδιάγραμμα Εκδήλωσης",
      "timelineSubtitle": "Αυτό έχουμε προγραμματίσει για εσάς",
      "arrival": "Άφιξη & Υποδοχή",
      "arrivalDesc": "Άφιξη στην εκκλησία Άγιος Γεώργιος",
      "cocktail": "Εκκλησιαστική τελετή",
      "cocktailDesc": "Γιορτάστε την ένωση",
      "dinner": "Άφιξη στον χώρο δείπνου Ballux Beach Bar",
      "dinnerDesc": "Ποτά υποδοχής, ορεκτικά και καθίσματα",
      "party": "Δείπνο & Κοπή Τούρτας",
      "partyDesc": "Απολαύστε μπουφέ δείπνο και επιδόρπιο",
      "memories": "Ώρα για Πάρτι",
      "memoriesDesc": "Χορέψτε όλη τη νύχτα",
      
      // Photos
      "shareMemories": "Μοιραστείτε τις Αναμνήσεις σας",
      "shareMemoriesDesc": "Ανεβάστε τις φωτογραφίες σας στο κοινό μας άλμπουμ",
      "uploadPhotos": "Ανέβασμα Φωτογραφιών",
      "uploadPhotosDesc": "Μοιραστείτε τις αγαπημένες σας στιγμές από την εκδήλωση",
      "uploadNow": "Ανέβασμα Τώρα",
      "allFormats": "Όλες οι Μορφές Δεκτές",
      "allFormatsDesc": "Φωτογραφίες, βίντεο και άλλα",
      "sharedAlbum": "Κοινό Άλμπουμ",
      "sharedAlbumDesc": "Όλοι μπορούν να δουν και να κατεβάσουν",
      "easyUpload": "Εύκολο Ανέβασμα",
      "easyUploadDesc": "Απλή διεπαφή μεταφοράς και απόθεσης",
      "viewGallery": "Προβολή & Λήψη Φωτογραφιών",
      "noLoginNeeded": "Δεν απαιτείται εφαρμογή ή σύνδεση.",
      "uploadTip": "Συμβουλή: Χρησιμοποιήστε Wi-Fi για μεγάλα βίντεο· οι φωτογραφίες ανεβαίνουν πιο γρήγορα από τον περιηγητή του κινητού σας.",
      "uploadSuccess": "Ευχαριστούμε! Οι φωτογραφίες σας ανέβηκαν.",
      "uploading": "Γίνεται ανέβασμα...",
      "filesSelected": "αρχεία επιλέχθηκαν",
      "galleryComingSoon": "Η γκαλερί θα είναι διαθέσιμη μετά τον γάμο",
      
      // Location
      "eventLocation": "Τοποθεσία Εκδήλωσης",
      "eventLocationDesc": "Θα μας βρείτε εδώ την μεγάλη μέρα",
      "nameOfVenue": "Εκκλησία Αγίου Γεωργίου & Ballux Beach Bar",
      "address": "Διεύθυνση",
      "location": "Στα Κάτω Λεχώνια του Βόλου",
      "phone": "Τηλέφωνο",
      "directions": "Οδηγίες",
      "getDirections": "Λήψη Οδηγιών",
      "openInMaps": "Άνοιγμα στο Google Maps",
      "parkingInfo": "Πληροφορίες Στάθμευσης",
      "parkingInfoDesc": "Διαθέσιμος δωρεάν χώρος στάθμευσης στον χώρο του γάμου",

      // Gift / Bank details
      "gift.intro": "Η παρουσία σας είναι το μεγαλύτερο δώρο και δεν περιμένουμε τίποτα άλλο! Αν θέλετε να μας δώσετε κάτι παρόλα αυτά, θα εκτιμούσαμε μια συνεισφορά στο μέλλον μας με τραπεζική μεταφορά. Εδώ είναι οι λεπτομέρειες:",
      "gift.germanyTitle": "Γερμανία (SEPA)",
      "gift.greeceTitle": "Ελλάδα (SEPA)",
      "gift.paypalTitle": "PayPal",
      "gift.accountHolder": "Κάτοχος λογαριασμού",
      "gift.iban": "IBAN",
      "gift.bic": "BIC",
      "gift.paypalEmail": "PayPal Email",
      "gift.paypalUsername": "PayPal Όνομα Χρήστη",
      "gift.reference": "Αναφορά",
      "gift.referenceValue": "Δώρο γάμου – Το όνομά σας",
      "gift.copyIban": "Αντιγραφή IBAN",
      "gift.copyEmail": "Αντιγραφή Email",
      "gift.copyAll": "Αντιγραφή όλων των λεπτομερειών",
      "gift.privacyNote": "Για την ιδιωτικότητά σας, παρακαλώ συμπεριλάβετε μόνο το όνομά σας στην αναφορά μεταφοράς. Σας ευχαριστούμε πολύ!",

      //FAQ 
      "faq.title": "Συχνές Ερωτήσεις",
      "faq.subtitle": "Όλα όσα πρέπει να ξέρετε για τη μεγάλη μας μέρα",
      "faq.question1": "Τι ώρα πρέπει να φτάσω;",
      "faq.answer1": "Συνιστούμε να φτάσετε στις 18:45. Η τελετή θα ξεκινήσει ακριβώς στις 19:00 στην εκκλησία. Αυτό σας δίνει χρόνο να βρείτε χώρο στάθμευσης και να τακτοποιηθείτε.",
      "faq.question2": "Υπάρχει κώδικας ενδυμασίας;",
      "faq.answer2": "Προτείνουμε κοκτέιλ/ημι-επίσημη ενδυμασία. Να γνωρίζετε ότι ο χώρος μετά την εκκλησία είναι στην παραλία, επομένως επιλέξτε τα παπούτσια σας ανάλογα (πλατφόρμες ή μπλοκ τακούνια λειτουργούν καλύτερα από τα στιλέτα στην άμμο).",
      "faq.question3": "Πού να μείνω;",
      "faq.answer3": "Έχουμε φτιάξει μια λίστα με προτεινόμενα καταλύματα Airbnb κοντά στον χώρο της εκδήλωσης και στο σπίτι που θα ετοιμαζόμαστε. Κάντε κλικ στην ενότητα καταλύματος παραπάνω για να δείτε τη λίστα καταλυμάτων στο Airbnb. Συνιστούμε να κάνετε κράτηση νωρίς καθώς ο Ιούνιος είναι περίοδος αιχμής στην περιοχή.",
      "faq.question4": "Πώς θα φτάσω στον Βόλο;",
      "faq.answer4": "Εδώ είναι οι επιλογές μεταφοράς σας:<br/><br/>• <strong>Αεροδρόμιο Αθήνας (ATH)</strong>: 3 ώρες οδήγηση. Επιλογές:<br/>  - Νοικιάστε αυτοκίνητο για ευελιξία<br/>  - Λεωφορείο από τον <a href='https://ktelvolou.gr/en/routes/map/&map=greece' target='_blank' rel='noopener noreferrer' style='color: #2563eb; text-decoration: underline; font-weight: 600;'>Σταθμό Λεωφορείων Αθήνας (ΚΤΕΛ)</a> προς Βόλο (4 ώρες)<br/><br/>• <strong>Αεροδρόμιο Θεσσαλονίκης (SKG)</strong>: 2,5 ώρες οδήγηση. Επιλογές:<br/>  - Νοικιάστε αυτοκίνητο για ευελιξία<br/>  - Απευθείας λεωφορείο από τον <a href='https://ktelmacedonia.gr/en/routes/tid=26' target='_blank' rel='noopener noreferrer' style='color: #2563eb; text-decoration: underline; font-weight: 600;'>Σταθμό Λεωφορείων Θεσσαλονίκης (ΚΤΕΛ)</a> προς Βόλο (2,5 ώρες)<br/><br/>Συνιστούμε να προσγειωθείτε στη Θεσσαλονίκη αν είναι δυνατόν, καθώς είναι πιο κοντά στον Βόλο.<br/><br/>Μόλις φτάσετε στον Βόλο, μπορείτε να πάρετε το τοπικό λεωφορείο για να φτάσετε στα Κάτω Λεχώνια, που απέχουν περίπου 20 λεπτά οδήγηση από το κέντρο του Βόλου.<br/><br/><b/><b/>Παρακαλώ μη διστάσετε να επικοινωνήσετε μαζί μας αν χρειαστείτε οποιαδήποτε βοήθεια με τη μεταφορά.",
      "faq.question5": "Μπορώ να φέρω τα παιδιά μου;",
      "faq.answer5": "Τα παιδιά είναι ευπρόσδεκτα! Παρακαλούμε να τα συμπεριλάβετε στην RSVP σας. Θα έχουμε κάποιες δραστηριότητες για παιδιά, αλλά συνιστούμε να φέρετε αντικείμενα για να τα απασχολήσετε κατά τη διάρκεια της τελετής.",
      "faq.question6": "Τι γίνεται με τα δώρα;",
      "faq.answer6": "Η παρουσία σας είναι το μεγαλύτερο δώρο και δεν περιμένουμε τίποτα άλλο! Αν θέλετε να μας δώσετε κάτι παρόλα αυτά, θα εκτιμούσαμε μια συνεισφορά στο ταμείο του μήνα του μέλιτος. Θα υπάρχει ένα κουτί δώρων στη δεξίωση.",
      "faq.moreQuestions": "Έχετε ακόμα ερωτήσεις;",
      "faq.contactUs": "Επικοινωνήστε μαζί μας",
      "faq.emailSubject": "Ερώτηση για τον Γάμο",
      
      // Accommodation
      "accommodation.title": "Πού να μείνετε",
      "accommodation.description": "Έχουμε δημιουργήσει μια λίστα με προτεινόμενα καταλύματα κοντά στον χώρο της εκδήλωσής μας και στο σπίτι που θα ετοιμαζόμαστε. Περιηγηθείτε στη λίστα καταλυμάτων στο Airbnb για τις καλύτερες επιλογές διαμονής κατά τη διάρκεια της επίσκεψής σας.",
      "accommodation.viewAirbnbs": "Δείτε τα προτεινόμενα καταλύματα",
      "accommodation.bookEarly": "Κάντε κράτηση νωρίς για την καλύτερη διαθεσιμότητα και τιμές!",

      // RSVP Form
      "rsvp": "Επιβεβαίωση παρουσίας",
      "rsvpDesc": "Παρακαλούμε ενημερώστε μας αν μπορείτε να έρθετε",
      "personalInfo": "Προσωπικές Πληροφορίες",
      "firstName": "Όνομα",
      "lastName": "Επώνυμο",
      "firstNamePlaceholder": "Γιάννης",
      "lastNamePlaceholder": "Παπαδόπουλος",
      "contactInfo": "Στοιχεία Επικοινωνίας",
      "email": "Email",
      "guestInfo": "Πληροφορίες Επισκεπτών",
      "adultsAllowed": "Αριθμός Ενηλίκων (max 2)",
      "childrenAllowed": "Αριθμός Παιδιών (max 5)",
      "adult": "Ενήλικας",
      "child": "Παιδί",
      "adults": "Ενήλικες",
      "children": "Παιδιά",
      "additionalInfo": "Επιπλέον Πληροφορίες",
      "allergies": "Αλλεργίες Τροφίμων",
      "allergiesPlaceholder": "Παρακαλώ αναφέρετε τυχόν αλλεργίες ή διατροφικούς περιορισμούς",
      "notes": "Επιπλέον Σημειώσεις",
      "notesPlaceholder": "Ειδικά αιτήματα ή πληροφορίες που πρέπει να γνωρίζουμε;",
      "submit": "Υποβολή",
      "submitting": "Υποβολή...",
      "thankYou": "Ευχαριστούμε!",
      "rsvpConfirmed": "Η συμμετοχή σας επιβεβαιώθηκε. Ανυπομονούμε να σας δούμε!",
      "submitAnother": "Υποβολή Άλλης Δήλωσης",
      "errorSubmitting": "Σφάλμα κατά την υποβολή. Παρακαλώ δοκιμάστε ξανά.",
      // Footer
      "footer": "Ελάτε να γιορτάσουμε τον γάμο μας! Φτιαγμένο με ❤️ από τη Βασιλική & τον Rodrigo."
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
